export default {
  "NO_DATA": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen data beschikbaar"])}
}